module.exports = __webpack_public_path__ + "img/Support-skill-118.ed7bf288.png";